import { useMutation } from "@apollo/client"
import { TOURNAMENT_FINISH } from "../queries/tournamentFinish"
import { useToast } from "@/hooks/use-toast"

interface TournamentFinishInput {
  tournamentId: number
}

export const useTournamentFinish = () => {
  const { toast } = useToast()

  const [tournamentFinishMutation, { loading }] = useMutation(TOURNAMENT_FINISH, {
    refetchQueries: ["TournamentListV2"],
    onCompleted: (data) => {
      if (data.TournamentFinish.status.success) {
        toast({
          title: "Torneo finalizado exitosamente",
          variant: "success",
          description: `El torneo ${data.TournamentFinish.Tournament.name} ha sido finalizado.`,
        })
      } else {
        toast({
          title: "Error al finalizar torneo",
          description: data.TournamentFinish.status.detail,
          variant: "destructive",
        })
      }
    },
    onError: (error) => {
      toast({
        title: "Error al finalizar torneo",
        description: error.message,
        variant: "destructive",
      })
    },
  })

  const tournamentFinish = async (input: TournamentFinishInput) => {
    const result = await tournamentFinishMutation({
      variables: { TournamentFinishInput: input },
    })
    return result.data?.TournamentFinish
  }

  return { tournamentFinish, loading }
}
